declare global {
  interface Window {
    __UR3PLS_BOOTSTRAP__?: boolean;
  }
}

/** Shared trip-link access checks (keep in sync with the inline gate in index.html). */
export const UR3PLS_BOOTSTRAP_FLAG = '__UR3PLS_BOOTSTRAP__';

export const STATIC_PAGE_NOT_FOUND_HTML = `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>Page not found</title>
  <meta name="robots" content="noindex,nofollow" />
  <link rel="icon" type="image/svg+xml" href="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Ccircle cx='8' cy='8' r='8' fill='%23e53935'/%3E%3Ctext x='8' y='12' text-anchor='middle' fill='white' font-size='11' font-family='sans-serif' font-weight='bold'%3E!%3C/text%3E%3C/svg%3E" />
</head>
<body>
  Page not found
</body>
</html>`;


export function hasTripAccessToken(): boolean {
  const urlToken =
    new URLSearchParams(window.location.search).get('token')?.trim() || '';
  if (urlToken) {
    return true;
  }

  try {
    const stored = sessionStorage.getItem('encryptedTripGUID')?.trim() || '';
    return stored.length > 0;
  } catch {
    return false;
  }
}

export function persistUrlTripToken(): void {
  const urlToken =
    new URLSearchParams(window.location.search).get('token')?.trim() || '';
  if (!urlToken) {
    return;
  }

  try {
    sessionStorage.setItem('encryptedTripGUID', urlToken);
  } catch {
    // sessionStorage may be unavailable in restricted browser modes
  }
}

export async function teardownClientCaches(): Promise<void> {
  const tasks: Promise<unknown>[] = [];

  if ('serviceWorker' in navigator) {
    tasks.push(
      navigator.serviceWorker.getRegistrations().then((registrations) =>
        Promise.all(registrations.map((registration) => registration.unregister())),
      ),
    );
  }

  if ('caches' in window) {
    tasks.push(
      caches.keys().then((keys) => Promise.all(keys.map((key) => caches.delete(key)))),
    );
  }

  await Promise.all(tasks);
}

/** Replaces the document with a static 404 and unloads the Angular application. */
export function renderStaticPageNotFound(): void {
  teardownClientCaches();
  document.open('text/html', 'replace');
  document.write(STATIC_PAGE_NOT_FOUND_HTML);
  document.close();
}

export function isBootstrapAllowed(): boolean {
  return (
    (window as Window & { __UR3PLS_BOOTSTRAP__?: boolean })
      .__UR3PLS_BOOTSTRAP__ === true
  );
}
